// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      clipPath="url(#a)"
    >
      <path d="M10.0013 18.3327C14.6037 18.3327 18.3346 14.6017 18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602C5.39893 1.66602 1.66797 5.39698 1.66797 9.99935C1.66797 14.6017 5.39893 18.3327 10.0013 18.3327Z" />
      <path d="M7.91797 7.47046C7.91797 7.07272 7.91797 6.87385 8.00109 6.76283C8.07352 6.66608 8.1844 6.60555 8.30495 6.59693C8.44329 6.58705 8.61057 6.69459 8.94514 6.90967L12.879 9.43856C13.1693 9.6252 13.3145 9.71852 13.3646 9.83717C13.4084 9.94085 13.4084 10.0578 13.3646 10.1615C13.3145 10.2802 13.1693 10.3735 12.879 10.5601L8.94514 13.089C8.61057 13.3041 8.44329 13.4116 8.30495 13.4018C8.1844 13.3932 8.07352 13.3326 8.00109 13.2359C7.91797 13.1248 7.91797 12.926 7.91797 12.5282V7.47046Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconPlayCircle = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconPlayCircle;
